import React from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import "./style.css";
import { images } from "../../../../constants/index";
import BackArrow from "../../../../components/backArrow";
const InvestmentDetails = () => {
  return (
    <Row>
      <div className="screenHeight d-flex justify-content-center align-items-center ">
        <Col lg="10" className="h-100">
          <div className="investment-details-wrapper b-radius shadow">
            <Container fluid="lg p-5 pt-1 pb-1 ">
              <BackArrow  />

              <h3 className="page-title mt-3">Project Alpha Investment Details</h3>

              {/* Summary Section */}
              <Card className="summary-card p-4 mb-4">
                <Row>
                  <Col md={6}>
                    <div className="text-muted small">Status</div>
                    <h6 className="fw-semibold">Investment Summary</h6>
                    <div className="text-muted">
                      Investment ID: INV-2023-12345
                    </div>
                    <Badge bg="muted" className="status-badge">
                      Active
                    </Badge>
                  </Col>
                  <Col md={6}  className="text-md-end text-center mt-3 mt-md-0">
                    <img
                      src={images.Wallet1}
                      alt="Selectezi"
                      className="selectezi-logo"
                      
                      
                    />
                  </Col>
                </Row>
              </Card>

              {/* Investment Highlights */}
              <Row className="g-3 text-center mb-4">
                <Col md={3} xs={6}>
                  <Card className="highlight-box p-4">
                    <div className="highlight-title">Total Investment</div>
                    <div className="highlight-value">Rs 250,000</div>
                  </Card>
                </Col>
                <Col md={3} xs={6}>
                  <Card className="highlight-box p-4">
                    <div className="highlight-title">Profit / Loss</div>
                    <div className="highlight-value text-success">
                      RS 100 &#8679;
                    </div>
                  </Card>
                </Col>
                <Col md={3} xs={6}>
                  <Card className="highlight-box p-4">
                    <div className="highlight-title">ROI Offered</div>
                    <div className="highlight-value">15%</div>
                  </Card>
                </Col>
                <Col md={3} xs={6}>
                  <Card className="highlight-box p-4">
                    <div className="highlight-title">Days Left</div>
                    <div className="highlight-value">30</div>
                  </Card>
                </Col>
              </Row>

              {/* Investment Breakdown */}
              <Card className="p-4 mb-4 detail-card">
                <Row className="mb-2">
                  <Col sm={6}>
                    <strong>Amount Invested:</strong> $10,000
                  </Col>
                  <Col sm={6}>
                    <strong>Current Value:</strong> $12,500
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={6}>
                    <strong>Profit/Loss:</strong> +25% (+$2,500)
                  </Col>
                  <Col sm={6}>
                    <strong>Investment Start Date:</strong> 2023-08-15
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <strong>Share/token:</strong> 10
                  </Col>
                  <Col sm={6}>
                    <strong>Total Duration:</strong> 3 months
                  </Col>
                </Row>
              </Card>

              {/* Manage Investment */}
              <Col lg="4" >
                <h5 className="fw-bold mb-3">Manage Investment</h5>
                <div className="d-flex flex-column gap-1">
                  <Button className="primary-btn-2 pt-2 pb-2">Withdraw Funds</Button>
                  <Button  className="secondary-btn-2 pt-2 pb-2">
                    Request Profit Payout
                  </Button>
                </div>
              </Col>
            </Container>
          </div>
        </Col>
      </div>
    </Row>
  );
};

export default InvestmentDetails;
